import script from "./payment_confirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment_confirm.vue?vue&type=script&setup=true&lang=ts"

import "./payment_confirm.vue?vue&type=style&index=0&id=1a18bfaa&scoped=true&lang=css"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a18bfaa"]])

export default __exports__